/** Enum to identify the area of the app where the error occurred */
export enum AppErrorArea {
  unknown = 'unknown',
  signup = 'signup',
  login = 'login',
  dashboard = 'dashboard',
  billing = 'billing',
}

/** An expandible error class that can be used to add additional data to the error, including area where the error occurred */
export class DebuggableError extends Error {
  debugData: Record<string, unknown>;

  constructor(
    message: string,
    extra?: {
      debugData?: Record<string, unknown>;
      area?: AppErrorArea;
    },
  ) {
    super(message);
    this.name = 'DebuggableError';
    this.debugData = extra?.debugData ?? {};
    this.debugData.area = extra?.area ?? AppErrorArea.unknown;
  }
}

/** Error specific to signup */
export class SignupError extends DebuggableError {
  constructor(message: string, extra?: { debugData?: Record<string, unknown> }) {
    super(message, { area: AppErrorArea.signup, ...extra });
  }
}
